<template>
  <div class="pt-3">
    <h3 class="is-size-6  has-text-weight-light">
      <span>{{ trip.startDate | formatDate }} </span>
      <span v-if="trip.startDate != trip.endDate"
        >- {{ trip.endDate | formatDate }}</span
      >
    </h3>

    <h2 class="is-size-5">{{ tripName }}</h2>

    <div class="is-size-7">
      Record locator:
      <span class="has-text-weight-bold ">
        {{ trip.recordLocator }}
      </span>
    </div>

    <div
      class="segment mt-3"
      v-for="(segment, index) in activeSegments"
      :key="index"
    >
      <div v-if="segment.type == 'air'">
        <div class="air-segment mb-4 pb-4">
          <div class="columns is-desktop">
            <div class="column">
              <div class="columns is-mobile">
                <div class="column">
                  <div>
                    <div></div>
                    <div class="is-size-6 is-inline-block">
                      {{ segment.startDate.date | formatDate }}
                                          <span
                      v-if="segment.startDate.date != segment.endDate.date"
                      class="is-size-7 has-text-danger ml-1"
                    >
                     +{{ getDiff(segment.endDate.date, segment.startDate.date) }} day
                    </span>
                    </div>

                  </div>
                  <h5 class="is-size-5 has-text-weight-light">
                    {{ $helpers.getAirlineName(segment.airline) }}
                  </h5>

                  <div>
                    <div class="is-size-7 has-text-grey">
                      Flight Number:

                      <span class="has-text-weight-bold has-text-grey-dark"
                        >{{ segment.airline }}{{ segment.flightNumber }}</span
                      >
                    </div>
                  </div>
                  <div class="is-size-7 has-text-grey-dark">
                    Confirmation Number:
                    <span class="has-text-weight-bold">{{
                      segment.confirmationNumber
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="columns is-mobile mb-0">
                <div class="column">
                  <div class="is-size-5 has-text-weight-bold has-text-info">
                    {{ segment.origin }}
                  </div>
                </div>
                <div class="column">
                  <div class="is-size-7 pt-3 has-text-centered">
                    <b-icon
                      icon="airplane"
                      class="has-text-grey"
                      custom-class="mdi-rotate-90"
                    ></b-icon>
                  </div>
                </div>
                <div class="column">
                  <div class="is-size-5 has-text-weight-bold has-text-info">
                    {{ segment.destination }}
                  </div>
                </div>
              </div>

              <div class="columns is-mobile">
                <div class="column pt-0">
                  <div class="is-size-7 has-text-grey mt-1">
                    Departs:
                  </div>
                  <div>
                    <span class="is-size-6 has-text-weight-bold">
                      {{ segment.startDate.time | formatTime }}
                    </span>
                  </div>
                </div>
                <div class="column"></div>
                <div class="column pt-0">
                  <div class="is-size-7 has-text-grey mt-1 ">
                    Arrives:
                  </div>

                  <div>
                    <span
                      class="is-size-6 has-text-weight-bold has-text-grey-dark"
                    >
                      {{ segment.endDate.time | formatTime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="segment.type == 'hotel'">
        <div class="columns">
          <div class="column">
            <h5 class="is-size-6">{{ segment.hotel.hotelName }}</h5>

            <div
              v-if="segment.hotel.address"
              class="has-text-grey mb-1 is-size-7"
            >
              <div>{{ segment.hotel.address.addressLine1 }}</div>

              <span>{{ segment.hotel.address.city }}</span>
              <span
                v-if="segment.hotel.address.city && segment.hotel.address.state"
                >,</span
              >
              <span> {{ segment.hotel.address.state }} </span>
              <span>{{ segment.hotel.address.postalCode }}</span>
            </div>

            <div class="is-size-7 has-text-grey is-block">
              Confirmation number:

              <span class="has-text-weight-bold has-text-grey-dark">
                {{ segment.confirmationNumber }}</span
              >
            </div>
          </div>

          <div class="column">
            <div class="is-size-7">
              {{ segment.tripLength }} night(s), starting in
              {{ segment.daysUntilStart }} days
            </div>

            <div class="columns mt-2 mb-0">
              <div class="column is-narrow">
                <h5 class="is-size-6 mb-1 has-text-grey">
                  <span class="is-size-7 is-block">Check-In:</span>
                  {{ segment.startDate.date | formatDate }}
                </h5>
              </div>
              <div class="column is-narrow">
                <h5 class="is-size-6 mb-1 has-text-grey">
                  <span class="is-size-7 is-block">Check-Out:</span>
                  {{ segment.endDate.date | formatDate }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>

<div v-if="segment.type == 'car'">

    
  <div class="car-segment">
    <div class="columns">
      <div class="column">
        <h5 class="is-size-5">{{ segment.carProvider.name }}</h5>

        <div class="is-size-7">
            Confirmation number:
          
          <span class="has-text-weight-bold">
            {{ segment.confirmationNumber }}</span>
          </div>

        <div class="columns mt-2 mb-0">
          <div class="column">
            <h5 class="is-size-6 mb-1">
              <div class="is-size-7">Pick-Up:</div>
              {{ segment.startDate.date | formatDate }} @
              {{ segment.startDate.time | formatTime }}
              <div class="has-text-grey is-size-7">{{
                segment.pickupLocation
              }}</div>
            </h5>
          </div>
          <div class="column">
            <h5 class="is-size-6 mb-2">
              <div class="is-size-7">Drop-Off:</div>
              {{ segment.endDate.date | formatDate }} @
              {{ segment.endDate.time | formatTime }}
              <div class="has-text-grey is-size-7">{{
                segment.dropoffLocation
              }}</div>
            </h5>
          </div>
        </div>

        <div class="mb-4" v-if="segment.pricingInfo">
          Estimated Total:
          {{ segment.pricingInfo.total | formatPriceFromDollars(2) }}
          <span class="has-text-grey"
            >({{
              segment.pricingInfo.averagePricePerDay
                | formatPriceFromDollars(2)
            }}/day)</span
          >
        </div>

      </div>
    </div>
  </div>

</div>

    </div>
  </div>
</template>

<script>
import router from "@/router";
import { saveAs } from "file-saver";
import moment from "moment";
export default {
  components: {},
  props: {
    trip: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    //TO DO: Return "Your previous trip" if past end date
    startsInDays() {
      if (this.trip.tripSummary?.daysUntilStart == 0) {
        return "Starts today";
      } else if (this.trip.tripSummary?.daysUntilStart > 0) {
        return "Starts in " + this.trip.tripSummary.daysUntilStart + " days";
      } else if (this.trip.tripSummary?.daysUntilStart < 0) {
        return "Your current trip";
      }
      return null;
    },
    tripName() {
      if (this.trip.tripSummary.tripName) {
        return this.trip.tripSummary.tripName;
      } else {
        return this.trip.tripSummary.cityState;
      }
    },
    activeSegments(){
      return this.trip.segments?.filter(
        (segment) => segment.status != "cancelled"
      );
    }
  },
  methods: {
    getDiff(start, end){
      return moment(start).diff(moment(end), 'days');
    }
  },
};
</script>

<style></style>
